export default {
      id: "graph-longueuil-usage",
      viewBox: "0 0 173 108",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-longueuil",
      toString: function () {
        return this.url;
      }
    }